export enum Feature {
  FAVORITES = 'favorites',
  EXPORT = 'export',
}
